import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import AdminLayout from './layouts/AdminLayout';
import HomeLanding from './pages/HomeLanding';
import About from './pages/About';
import Objectives from './pages/Objectives';
import News from './pages/News';
import NewsPost from './pages/NewsPost';
import Team from './pages/Team';
import Services from './pages/Services';
import Gallery from './pages/Gallery';
import Partnerships from './pages/Partnerships';
import Contact from './pages/Contact';
import Careers from './pages/Careers';
import FAAct from './pages/FAAct';
import CodexActivities from './pages/CodexActivities';
import BusinessRegistry from './pages/BusinessRegistry';
import FoodPremises from './pages/FoodPremises';
import BusinessDashboard from './pages/BusinessDashboard';
import BusinessLogin from './pages/BusinessLogin';
import AdminLogin from './pages/Admin/Login';
import AdminDashboard from './pages/Admin/Dashboard';
import ProtectedRoute from './components/ProtectedRoute';
import BusinessProtectedRoute from './components/BusinessProtectedRoute';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/admin/login" element={
          <AdminLayout>
            <AdminLogin />
          </AdminLayout>
        } />
        <Route path="/admin/*" element={
          <AdminLayout>
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          </AdminLayout>
        } />
        
        <Route path="/business/login" element={
          <MainLayout>
            <BusinessLogin />
          </MainLayout>
        } />

        <Route path="/business-dashboard" element={
          <AdminLayout>
            <BusinessProtectedRoute>
              <BusinessDashboard />
            </BusinessProtectedRoute>
          </AdminLayout>
        } />

        <Route path="/*" element={
          <MainLayout>
            <Routes>
              <Route path="/" element={<HomeLanding />} />
              <Route path="/food-premises" element={<FoodPremises />} />
              <Route path="/about" element={<About />} />
              <Route path="/objectives" element={<Objectives />} />
              <Route path="/news" element={<News />} />
              <Route path="/news/:id" element={<NewsPost />} />
              <Route path="/team" element={<Team />} />
              <Route path="/services" element={<Services />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/partnerships" element={<Partnerships />} />
              <Route path="/codex-activities" element={<CodexActivities />} />
              <Route path="/fa-act" element={<FAAct />} />
              <Route path="/business-registry" element={<BusinessRegistry />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="/career" element={<Navigate to="/careers" replace />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </MainLayout>
        } />
      </Routes>
    </Router>
  );
}

export default App;
